import {useState} from 'react'
import './App.css'
import { Route, Routes } from 'react-router-dom';

import Home from './pages/home/Home';
import Collection from './pages/collection/Collection';
import GetQuote from './pages/getquote/GetQuote';
import Industries from './pages/industries/Industries';
import Processing from './pages/processing/Processing';
import Analysis from './pages/analysis/Analysis';
import Layout from './components/layout/Layout.jsx';

function App() {

    return (
        <>
            <Routes>
                <Route element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="/collection" element={<Collection />} />
                    <Route path="/quote" element={<GetQuote />} />
                    <Route path="/industries" element={<Industries />} />
                    <Route path="/processing" element={<Processing />} />
                    <Route path="/solutions" element={<Analysis />} />
                    {/*<Route path="/lidar" element={<LidarExplorer />} />*/}
                    {/*<Route path="/contact" element={<Contact />} />*/}
                    <Route path="*" element={<Home />} />
                </Route>
            </Routes>
        </>
    )
}

export default App
